import { gql } from "@apollo/client";

export const SEND_REDEEM_INVITATION = gql`
    mutation SendRedeemInvitation ($data: RedeemInvitationInput!) {
        sendRedeemInvitation (data: $data) {
            success
        }
    }
`;
